module.exports = {
  menuHomeLabel: 'Home',
  menuBenefitsLabel: 'Ventajas',
  menuEarningsLabel: 'Ganancias como consultor/a',
  menuOurCausesLabel: 'Consultoría de Belleza',
  menuHelpLabel: 'Preguntas Frecuentes',
  homeId: 'home',
  homeHeroSectionId: 'hero',
  homeHeroCTAButtonText: 'Regístrate aquí',
  homeHeroCTAButtonAccessibleLabel: 'Registrarse',
  homeHeroSubtitle:
    '¡Cuando nos encontramos, nos apoyamos y tu vas más lejos! Únete a la Consultoría de Belleza Natura y Avon y transforma tu vida y el mundo.',
  homeHeroTitle: 'Vive la Belleza del Encuentro',
  homeHeroImageAlt: 'Mulher sorrindo segurando um celular. Ao lado esquerdo, produtos da Natura em cima da mesa.',
  homePageTitle: 'Quiero ser Consultora',
  benefitsSectionId: 'beneficios',
  benefitsHeadingTitle: 'Ventajas',
  benefitsHeadingSubtitle:
    'En la Consultoría de Belleza Natura y Avon, la pasión por las relaciones encuentra la pasión por la cosmética. Dos grandes marcas y más posibilidades para que atiendas a tus clientes. Mira cuales son las ventajas que tenemos para ti:',
  benefitHealthTitle: 'Productos de Calidad',
  benefitHealthText:
    'Tenemos los productos más deseados del mercado peruano. La calidad e innovación de nuestros productos hacen fácil su venta, y sobretodo son seguros para ti y para el medioambiente.',
  benefitEducationTitle: 'Oportunidad de ganancias',
  benefitEducationText:
    'Aumenta tus ganancias y conquista más beneficios al evolucionar en el Camino de Crecimiento, un programa hecho para que prosperes y crescas a tu ritmo junto a Natura y Avon. ¡Todas tus ventas suman puntos!',
  appTitle: 'Entrenamientos',
  appText: 'Tendrás capacitaciones a tu disposición para tu desarolllo personal y profesional, con herramientas que te permitirán conocer nuestros productos y cómo potencializar tu negocio.',
  benefitOnlineSellsTitle: 'Productos innovadores',
  benefitOnlineSellsText:
    'Ofreces una Consultoría de Belleza llena de productos innovadores junto con los mejores ingredientes y tecnología que caracterizan a Natura y Avon. Además de las opciones de Casa y Estilo para deleitar a tus clientes en cualquier momento.',
  benefitBonusTitle: 'Eventos y Reconocimientos',
  benefitBonusText:
    'Reconocemos el esfuerzo y la dedicación que pones en alcanzar todos tus logros, por eso, queremos celebrar contigo cada uno de tus éxitos a través de eventos, reconocimientos e increíbles viajes.',
  benefitRecognitionTitle: 'Campañas de ventas',
  benefitRecognitionText:
    'Participa en nuestras campañas de ventas y gana increíbles premios y viajes de incentivos.',
  benefitRegisterButtonText: 'Regístrate aquí',
  ctaButtonLinkDesktop:
    'https://accounts.natura-avon.com/document?country=ec&company=natura',
  ctaButtonLinkMobile:
    'https://accounts.natura-avon.com/document?country=ec&company=natura',
  earningsSectionId: 'ganancias-como-consultora',
  earningsHeadingTitle: 'Ganancias como Consultora o Consultor',
  earningsHeadingSubtitle:
    'Puedes elegir vender Natura, Avon o ambas marcas a través de nuestro modelo de venta directa, donde todas tus ventas suman para tu Camino de Crecimiento. Cuanto mayor sea tu nivel, mayores serán tus ganancias.',
  earningsProduct1Title: 'Ekos Castaña: S/. 38',
  earningsProduct1Description: '100% vegano y conserva la Amazonia brasileña',
  earningsProduct2Title: 'Tododia Frutas Rojas',
  earningsProduct2Description: 'Nutrición prebiótica y ingredientes naturales',
  earningsProduct3Title: 'Ekos Frescor Maracuyá: S/. 84',
  earningsProduct3Description:
    'Eau de toilette extraído de las semillas del maracuyá',
  earningsProduct4Title: 'Shampoo Lumina: S/. 26',
  earningsProduct4Description:
    'Biotecnologia pró-teia y frasco de plástico verde',
  earningsCalculatorChartResultText: 'Tu cliente compra este kit por:',
  earningsCalculatorChartResultDescription:
    '{salesType, select, true {Tu ganancia de acuerdo a tu nivel en<br/> Camino de Crecimiento es:} false {Tu ganancia en Venta online, según tu <br/> nivel es:}}',
  earningsChartLevelSeed: 'Semilla',
  earningsChartLevelBronze: 'Bronce',
  earningsChartLevelSilver: 'Plata',
  earningsChartLevelGold: 'Oro',
  earningsChartLevelDiamond: 'Diamante',
  onlineSalesButtonText: 'Ventas Online',
  regularSalesButtonText: 'Ventas por Revista',
  ourCausesSectionId: 'nuestras-causas',
  ourCausesHeadingTitle: 'Consultoría de Belleza',
  ourCausesHeadingSubtitle: 'Cuando nos encontramos, hay más potencia, vamos más allá, vivimos nuestro propósito, movilizamos y transformamos el mundo. Nunca fue solamente una venta de productos.',
  ourCausesAmazonTitle: 'Facilidad para tu día a día.',
  ourCausesAmazonText:
    '<strong>Facilidad para tu día a día</strong> <br/>¡Incluye los productos Natura y Avon en un solo pedido, recíbelos todos en la misma caja y paga una única factura! Simple, ¿no?<br /> <br/> Con pedidos, pagos e incluso entrenamientos organizados en un solo lugar, tendrás todo el apoyo para dar lo mejor de ti y brillar en el negocio.',
  ourCausesRecyclingTitle: 'Más prosperidad para ti',
  ourCausesRecyclingText:
    '<strong>Más prosperidad para ti</strong> <br/>Puedes sumar puntos con productos de ambas marcas para el Camino de Crecimiento, lo que acelera tu desarrollo como Consultor o Consultora de Belleza.<br /><br /> Son más las posibilidades de ganancias, independencia para tu rutina, aprendizajes y ventajas, ¡todo para que puedas expandir tus ventas y obtener muchos más beneficios!',
  phone: '0800.115.566',
  helpSectionId: 'preguntas-frecuentes',
  helpHeadingTitle: 'Preguntas Frecuentes',
  footerTitle: 'Vea también',
  footerCallCenterLabel: 'SAC',
  footerCopyRightLabel: 'Todos los derechos reservados.',
  graphTitle: 'Tu ganancia de acuerdo a tu nivel en Camino de Crecimiento es:',
  graphCompany: 'NATURA | AVON',
  brass: 'BRONCE',
  brassPercent: '25%',
  silver: 'PLATA',
  silverPercent: '30%',
  golden: 'ORO',
  goldenPercent: '32%',
  zaphir: 'ZAFIRO',
  zaphirPercent: '35%',
  diamond: 'DIAMANTE',
  diamondPercent: '37%',
  graphParagraph: '*Revisar condiciones en la Consultoría vigente del ciclo.<br />** Para productos de Casa y Estilo el descuento es de 15%, independiente del nivel.'

}
